<ion-content>
  <app-global-page-header
    [title]="'functions.filtration.usagemode.title' | translate"
  >
    <div slot="end">
      <ion-button
        color="medium"
        fill="clear"
        shape="round"
        (click)="dismissModal()"
      >
        <i class="fa-solid fa-times"></i>
      </ion-button>
    </div>
  </app-global-page-header>

  <div class="p-4">
    <p
      class="my-2 mb-4 color-medium"
      [innerHTML]="'P0003605.esp.text' | translate | nl2Br"
    ></p>

    <div>
      <table
        class="table table-bordered"
        style="width: 100%; border-width: 2px !important"
      >
        <tr>
          <th class="fw-normal p-1 color-medium">
            {{ 'P0003605.esp.tab.debit' | translate }}
          </th>
          <th class="fw-bold p-1 color-medium">1.6</th>
          <th class="fw-bold p-1 color-medium">2.4</th>
          <th class="fw-bold p-1 color-medium">3</th>
        </tr>
        <tr>
          <td class="p-1 color-medium">
            {{ 'P0003605.esp.tab.bassin' | translate }}
          </td>
          <td class="p-1 color-medium">40</td>
          <td class="p-1 color-medium">70</td>
          <td class="p-1 color-medium">90</td>
        </tr>
      </table>
    </div>
  </div>
</ion-content>
